import { Box, css, styled } from '@mui/material';

export const SidebarItemContainer = styled(Box)(
  ({ theme }) => css`
    padding: ${theme.spacing(2)};
  `,
);
